"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      form: {},
      id: this.$route.query.id || ''
    };
  },
  mounted: function mounted() {
    if (this.id > 0) {
      this.getInfo();
    }
  },
  methods: {
    /**
     * 获取商户信息
     */
    getInfo: function getInfo() {
      var _this = this;
      this.$get('agentapi/ad_detail', {
        id: this.id
      }).then(function (res) {
        _this.time = [res.info.start_date * 1000, res.info.end_date * 1000];
        _this.fileList = [{
          url: res.info.img_url
        }];
        res.info.is_all = res.info.is_all == 1 ? true : false;
        _this.form = res.info;
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      var params = this.form,
        url = 'agentapi/fund/add_order';
      params.expect_finish_date = this.parseTime(params.expect_finish_date);
      if (this.id > 0) {
        params.id = this.id;
        url = 'agentapi/edit_ad';
      }
      this.$post(url, params).then(function (res) {
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
        _this2.$router.push({
          path: '/order/accredit'
        });
      });
    }
  }
};